var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#0B4A42"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3765_50121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 12.6665H15.3333C14.4496 12.6676 13.6024 13.0191 12.9775 13.644C12.3526 14.2689 12.0011 15.1161 12 15.9998V23.9998C12.0011 24.8836 12.3526 25.7308 12.9775 26.3557C13.6024 26.9806 14.4496 27.3321 15.3333 27.3332H24.6667C25.5504 27.3321 26.3976 26.9806 27.0225 26.3557C27.6474 25.7308 27.9989 24.8836 28 23.9998V15.9998C27.9989 15.1161 27.6474 14.2689 27.0225 13.644C26.3976 13.0191 25.5504 12.6676 24.6667 12.6665ZM15.3333 13.9998H24.6667C25.0659 14.0006 25.4557 14.1208 25.786 14.345C26.1163 14.5692 26.3719 14.8871 26.52 15.2578L21.4147 20.3638C21.039 20.738 20.5303 20.9481 20 20.9481C19.4697 20.9481 18.961 20.738 18.5853 20.3638L13.48 15.2578C13.6281 14.8871 13.8837 14.5692 14.214 14.345C14.5443 14.1208 14.9341 14.0006 15.3333 13.9998ZM24.6667 25.9998H15.3333C14.8029 25.9998 14.2942 25.7891 13.9191 25.4141C13.544 25.039 13.3333 24.5303 13.3333 23.9998V16.9998L17.6427 21.3065C18.2684 21.9307 19.1162 22.2812 20 22.2812C20.8838 22.2812 21.7316 21.9307 22.3573 21.3065L26.6667 16.9998V23.9998C26.6667 24.5303 26.456 25.039 26.0809 25.4141C25.7058 25.7891 25.1971 25.9998 24.6667 25.9998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3765_50121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.4517fd92a724b62f3bfe74478c3212ba.svg";
export { ForwardRef as ReactComponent };